export const IMPORT_P4_NEW_MIGRATION_OPEN_MODAL = "IMPORT_P4_NEW_MIGRATION_OPEN_MODAL"
export const IMPORT_P4_SEARCH_ACCOUNTS_REQUEST = "IMPORT_P4_SEARCH_ACCOUNTS_REQUEST"
export const IMPORT_P4_SEARCH_ACCOUNTS_RESULT = "IMPORT_P4_SEARCH_ACCOUNTS_RESULT"
export const IMPORT_P4_GET_ACCOUNT_REQUEST = "IMPORT_P4_GET_ACCOUNT_REQUEST"
export const IMPORT_P4_GET_ACCOUNT_RESULT = "IMPORT_P4_GET_ACCOUNT_RESULT"
export const IMPORT_P4_IMPORT_REQUEST = "IMPORT_P4_IMPORT_REQUEST"
export const IMPORT_P4_IMPORT_RESULT = "IMPORT_P4_IMPORT_RESULT"
export const IMPORT_P4_GET_STATUS_REQUEST = "IMPORT_P4_GET_STATUS_REQUEST"
export const IMPORT_P4_GET_STATUS_RESULT = "IMPORT_P4_GET_STATUS_RESULT"
export const IMPORT_P4_GET_ACCOUNT_BY_PX_REQUEST = "IMPORT_P4_GET_ACCOUNT_BY_PX_REQUEST"
export const IMPORT_P4_GET_ACCOUNT_BY_PX_RESULT = "IMPORT_P4_GET_ACCOUNT_BY_PX_RESULT"
